import { useState } from 'react';
// import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next';

import RegisterForm from 'components/RegisterForm/RegisterForm';
import FormContainer from 'uI/FormContainer/FormContainer';
import MyDegree from 'uI/MyDegree/MyDegree';

import classes from './Register.module.css';

const Register = () => {
  const { t } = useTranslation(['register']);
  const [userName, setUserName] = useState('');
  const [userLastName, setUserLastName] = useState('');

  const changeNameHandler = name => {
    setUserName(name);
  };

  const changeLastNameHandler = lastName => {
    setUserLastName(lastName);
  };

  return (
    <div className={classes.formSectionRegister}>
      <FormContainer
        title={t('principal_text')}
        subtitle={t('have_account')}
        btnLink="login"
        btnText={t('login')}
      >
        <RegisterForm
          changeName={changeNameHandler}
          changeLastName={changeLastNameHandler}
        />
      </FormContainer>
      <MyDegree
        demoProfile
        name={userName}
        lastName={userLastName}
      />
    </div>
  );
};

export default Register;
